import React from 'react';
import * as cls from './benefits.module.css';
import { Link } from 'react-router-dom';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';
import { Section } from '../../../ui/components/section';
import { Button } from '../../../ui/components/button';
import { CarouselHalf } from '../../../ui/components/carousel-half';
import { Typography } from '../../../ui/components/typography';

const items = [
  {
    ico: `${IMG_PATH}/utilities/ico-know-your-customers.svg`,
    title: 'Know Your Customers (KYC for Utilities)',
    text: 'Appliance-level profiles reveal who uses what, when, and why - giving you true customer understanding at scale.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-high-precision-personalisation.svg`,
    title: 'High-Precision Personalisation',
    text: 'Turn KYC into action: deliver the right tariff, product, or advice to the right customer at the right moment.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-know-what-to-sell.svg`,
    title: 'Know What to Sell (and When)',
    text: 'Behavioural profiling highlights upgrade opportunities and pinpoints customers most likely to convert.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-lower-cost-to-serve.svg`,
    title: 'Lower Cost-to-Serve',
    text: 'Proactive insights reduce high-bill complaints and call-centre load.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-prove-roi.svg`,
    title: 'Prove ROI',
    text: 'Demonstrate measurable savings and CO₂ reductions to regulators, investors, and customers.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-drive-new-revenue-streams.svg`,
    title: 'Drive New Revenue Streams',
    text: 'Upsell electrification upgrades, cross-sell services like smart tariffs, usage-based insurance, or efficiency kits.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-increase-retention-and-lower-churn.svg`,
    title: 'Increase Retention & Lower Churn',
    text: 'Provide insights via dashboards, APIs, or branded apps, whichever best fits your strategy.',
  },
  {
    ico: `${IMG_PATH}/utilities/ico-deploy-fast.svg`,
    title: 'Deploy Fast',
    text: 'Go live in as little as 1 week using smart meter data; scale to real-time when ready.',
  },
];

export const Benefits = () => {
  return (
    <Section>
      <Typography tag="h2">Benefits for Utilities</Typography>

      <div className={cls['carousel-wrapper']}>
        <CarouselHalf className={cls.carousel}>
          {items.map((item, index) => (
            <div className={cls.item} key={index}>
              <div className={cls.item__title}>
                <img src={item.ico} alt="" />
                <Typography as="p" tag="h3">
                  {item.title}
                </Typography>
              </div>
              <Typography>{item.text}</Typography>
            </div>
          ))}
        </CarouselHalf>
      </div>

      <div className={cls.button}>
        <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
          <Button>Request Demo</Button>
        </Link>
      </div>
    </Section>
  );
};
